<template>
  <div class="hideTotal">
    <table-search
      label-width="65px"
      @search="fetchGoodsData(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <el-form-item
          label="日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.bizDate"
            type="date"
            placeholder="请选择日期"
          />
        </el-form-item>
        <el-form-item label="主体">
          <el-select v-model="query.companyId">
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="exportExcel('LOAN')" />
    <el-table
      ref="zTable"
      :data="[tableData]"
      border
      default-expand-all
    >
      <el-table-column type="expand">
        <el-table
          :data="tableData && tableData.detailVos || []"
          border
        >
          <el-table-column
            prop="bizDate"
            min-width="120"
            label="时间"
          >
            <template slot-scope="scope">
              {{ dayJs(scope.row.bizDate).format('YYYY-MM-DD') }}
            </template>
          </el-table-column>
          <el-table-column
            prop="billType"
            min-width="100"
            label="单据类型"
          />
          <el-table-column
            prop="projectName"
            min-width="250"
            label="收支项目"
          />
          <el-table-column
            prop="description"
            min-width="350"
            label="摘要"
          />
          <el-table-column
            prop="inAmount"
            min-width="100"
            label="入金"
          />
          <el-table-column
            prop="outAmount"
            min-width="100"
            label="出金"
          />
          <el-table-column
            prop="bankAccount"
            min-width="100"
            label="银行账号"
          />
          <el-table-column
            prop="bankName"
            min-width="100"
            label="银行名称"
          />
          <el-table-column
            prop="companyName"
            min-width="210"
            label="结算单位"
          />
          <el-table-column
            prop="unitName"
            min-width="120"
            label="进出款单位"
          />
          <el-table-column
            prop="billNumber"
            min-width="210"
            label="单据编码"
          />
        </el-table>
      </el-table-column>
      <el-table-column
        prop="memberNumber"
        min-width="100"
        label="客户号"
      />
      <el-table-column
        prop="areaName"
        min-width="100"
        label="区域名称"
      />
      <el-table-column
        prop="lastDayBalance"
        min-width="100"
        label="期初货款"
      />
      <el-table-column
        prop="todayAdd"
        min-width="100"
        label="总计转入"
      />
      <el-table-column
        prop="todayReduce"
        min-width="100"
        label="总结转出"
      />
      <el-table-column
        prop="todayBalance"
        min-width="100"
        label="期末货款"
      />
      <el-table-column
        prop="frozenBalance"
        min-width="120"
        label="冻结货款余额"
      />
      <el-table-column
        prop="canUseBalance"
        min-width="100"
        label="可用货款"
      />
    </el-table>
  </div>
</template>

<script>
import api from '@/api'
import dayJs from 'dayjs'
import mixin from '@/utils/mixinFile'

function Query () {
  // earlySettlement 提前 20 到期10
  this.bizDate = new Date()
  this.companyId = 'hCsAAAAAAYDM567U'
  this.memberNumber = ''
  this.token = ''
}
export default {
  name: 'DailyStatement',
  mixins: [mixin],
  data () {
    return {
      query: new Query(),
      tableData: [],
      // 主体数组
      companyList: [],
      dayJs: dayJs
    }
  },
  async created () {
    api.spotPurchaseSaleInquiry.getToken().then((res) => {
      this.query.token = res
      this.query.bizDate = this.$route.query.date || new Date()
      this.query.memberNumber = JSON.parse(localStorage.getItem('pro__USER_INFO')).value.account
      this.getAllCompany()
      this.fetchGoodsData()
    })
  },
  methods: {
    async fetchGoodsData () {
      if (!this.query.bizDate) {
        this.$message.error('请输入日期')
        return
      }

      let param = Object.assign({}, this.query)

      param.bizDate = `${dayJs(this.query.bizDate).format('YYYY-MM-DD')} 23:59:59`

      let res = await api.spotPurchaseSaleInquiry.dailyStatementDataList(param)
      this.tableData = res.data
    },
    async getAllCompany () {
      this.companyList = (await api.spotPurchaseSaleInquiry.getAllCompany(this.query)).data
      // 取数组最后一个为默认主体
      // this.query.companyId = this.companyList[this.companyList.length && this.companyList.length - 1].id
    },
    changePage (page) {
      this.fetchGoodsData(page)
    },
    handleReset () {
      this.query.companyId = 'hCsAAAAAAYDM567U'
      this.query.bizDate = new Date()
      this.fetchGoodsData(1)
    }
  }
}

</script>
<style lang="scss" scoped>
  .inqueryResult+div {
    margin-top: 15px;
    border: none;
  }

</style>
